import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import MediaModal from './MediaModal';
import './InformativoCard.css';

export default function InformativoCard({ informativo, onEdit, onDelete, canEdit, onMarkAsViewed, onUnmarkAsViewed, isViewed = false }) {
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);

  const apiBase = process.env.REACT_APP_URL_BASE || '';
  const apiOrigin = apiBase.replace(/\/api\/?$/i, '').replace(/\/$/, '');

  const formattedDate = new Date(informativo.createdAt).toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const expirationText = informativo.isIndefinite
    ? 'Sem data de expiração'
    : new Date(informativo.expiresAt) > new Date()
    ? `Expira em ${new Date(informativo.expiresAt).toLocaleDateString('pt-BR')}`
    : 'Expirado';

  const handleCardClick = () => {
    if (informativo.images && informativo.images.length > 0) {
      setSelectedMediaIndex(0);
      setShowMediaModal(true);
    }
  };

  return (
    <>
      <div className="informativo-card" id={`informativo-card-${informativo.id}`}>
        {/* Mídia carousel */}
        {informativo.images && informativo.images.length > 0 && (
          <div 
            className="card-images clickable"
            onClick={handleCardClick}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => e.key === 'Enter' && handleCardClick()}
          >
            <div className="image-carousel">
              {informativo.images[0].toLowerCase().endsWith('.pdf') ? (
                <div className="pdf-thumbnail">
                  <div className="pdf-icon">📄</div>
                </div>
              ) : (
                <img
                  src={`${apiOrigin}/uploads/${informativo.images[0]}`}
                  alt="Informativo"
                  className="card-image"
                />
              )}
              {informativo.images.length > 1 && (
                <div className="image-count">
                  +{informativo.images.length - 1}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Conteúdo */}
        <div className="card-content">
          <h3 className="card-title">{informativo.title}</h3>

          {informativo.description && (
            <p className="card-description">
              {informativo.description.substring(0, 150)}
              {informativo.description.length > 150 ? '...' : ''}
            </p>
          )}

          {/* Metadata */}
          <div className="card-metadata">
            <div className="meta-item">
              <span className="meta-label">Publicado por:</span>
              <span className="meta-value">
                {informativo.createdBy?.fullName || 'Sistema'}
              </span>
            </div>

            <div className="meta-item">
              <span className="meta-label">Data:</span>
              <span className="meta-value">{formattedDate}</span>
            </div>

            <div className="meta-item">
              <span className={`meta-value expiration ${informativo.isIndefinite ? '' : new Date(informativo.expiresAt) <= new Date() ? 'expired' : ''}`}>
                {expirationText}
              </span>
            </div>
          </div>

          {/* Ações */}
          <div className="card-actions">
            {/* Botão marcar/desmarcar como visto */}
            {isViewed ? (
              <button
                className="btn btn-outline-secondary"
                onClick={() => onUnmarkAsViewed && onUnmarkAsViewed(informativo.id)}
                title="Desmarcar como visto"
              >
                <FaEyeSlash />
                <span className="btn-text">Não visto</span>
              </button>
            ) : (
              <button
                className="btn btn-success"
                onClick={() => onMarkAsViewed && onMarkAsViewed(informativo.id)}
                title="Marcar como visto"
              >
                <FaEye />
                <span className="btn-text">Visto</span>
              </button>
            )}

            {canEdit && (
              <>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={onEdit}
                >
                  Editar
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={onDelete}
                >
                  Deletar
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Modal de mídia */}
      {showMediaModal && (
        <MediaModal
          medias={informativo.images || []}
          initialIndex={selectedMediaIndex}
          onClose={() => setShowMediaModal(false)}
        />
      )}
    </>
  );
}
